import { useIsLoggedInRetailer } from "@faire/retailer-visitor-shared/lib/isLoggedInRetailer";
import { useOpenWithFaireApplicationStatus } from "@faire/retailer-visitor-shared/stores/domain/OpenWithFaire/useOpenWithFaireApplicationStatus";

export enum FAIRE_ACADEMY_PAGE_STATE {
  LOGGED_OUT = "LOGGED_OUT",
  LOGGED_IN_ESTABLISHED = "LOGGED_IN_ESTABLISHED",
  LOGGED_IN_NEW_NOT_APPLIED = "LOGGED_IN_NEW_NOT_APPLIED",
  LOGGED_IN_NEW_APPLIED = "LOGGED_IN_NEW_APPLIED",
}

export const useGetFaireAcademyPageState = () => {
  const {
    isOwFExpired,
    isNotEligibleForOwF,
    canApply,
    hasApplicationPendingReview,
    isOnHold,
    isRejectedForOwF,
    isAccepted,
  } = useOpenWithFaireApplicationStatus();

  const isLoggedInRetailer = useIsLoggedInRetailer();

  const isLoggedOut = !isLoggedInRetailer;
  const isLoggedInEstablished =
    isLoggedInRetailer && (isOwFExpired || isNotEligibleForOwF);
  const isLoggedInNewApplied =
    isLoggedInRetailer &&
    (hasApplicationPendingReview || isOnHold || isRejectedForOwF || isAccepted);
  const isLoggedInNewNotApplied = isLoggedInRetailer && canApply;

  let pageState: keyof typeof FAIRE_ACADEMY_PAGE_STATE =
    FAIRE_ACADEMY_PAGE_STATE.LOGGED_OUT;

  if (isLoggedInEstablished) {
    pageState = FAIRE_ACADEMY_PAGE_STATE.LOGGED_IN_ESTABLISHED;
  } else if (isLoggedInNewApplied) {
    pageState = FAIRE_ACADEMY_PAGE_STATE.LOGGED_IN_NEW_APPLIED;
  } else if (isLoggedInNewNotApplied) {
    pageState = FAIRE_ACADEMY_PAGE_STATE.LOGGED_IN_NEW_NOT_APPLIED;
  }

  return {
    pageState,
    isLoggedOut,
    isLoggedInEstablished,
    isLoggedInNewNotApplied,
    isLoggedInNewApplied,
  };
};
